import styled, { createGlobalStyle } from 'styled-components';

import { CorUtil } from '@utils';

import { Conteiner as Input } from '../../../components/input/styles';

export const Global = createGlobalStyle`
  body {
    overflow-y: auto;
  }
`;

export const Conteiner = styled.div`
  display: flex;
  flex-direction: row;
  row-gap: 20px;

  width: 85%;

  .conteiner-tabela {
    grid-template-columns: auto 1fr;
    align-items: flex-end;
    column-gap: 2rem;
  }

  h1 {
    font-size: 1.25rem;
    color: ${(props) => props.theme.cores.primaria.padrao};
  }

  @media screen and (max-width: 1300px) {
    .conteiner-tabela {
      grid-template-columns: 1fr;
      grid-template-areas:
        'filtros filtros'
        'quantidade quantidade'
        'tabela tabela'
        'mensagem mensagem'
        'paginacao paginacao' !important;
      row-gap: initial !important;
    }
  }

  @media screen and (max-width: 1300px) {
    width: 100%;
  }

  @media screen and (max-width: 860px) {
    display: flex;
    flex-direction: column;
  }

  ${Input} {
    width: 100%;
  }
`;

export const Coluna = styled(Conteiner)`
  display: flex;
  flex-direction: column;

  padding: 16px 24px 32px 24px;
  height: fit-content;
  min-height: calc(100vh - 324px);

  background: ${(props) => CorUtil.rgba(props.theme.cores.neutro[0], 1)};
  border-right: 1px solid ${(props) => CorUtil.rgba(props.theme.cores.neutro[100], 1)};
  border-left: 1px solid ${(props) => CorUtil.rgba(props.theme.cores.neutro[100], 1)};

  @media screen and (max-width: 860px) {
    min-height: unset;
  }
`;

export const Filtros = styled.div`
  position: sticky;
  top: 80px;

  display: flex;

  height: fit-content;
  padding: 0 24px 24px 24px;

  @media screen and (max-width: 860px) {
    padding: 24px 16px 0 16px;
  }

  @media screen and (max-width: 860px) {
    top: 0;
    position: relative;
    height: 100%;
  }
`;

export const Formulario = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 20px;

  padding: 12px 0;

  width: 360px;
  max-width: 100%;

  p {
    font-weight: bold;
  }

  @media (max-width: 1200px) {
    max-width: 100%;
  }

  @media (max-width: 860px) {
    width: 100%;
    max-width: 100%;
    padding: 0;
  }
`;

export const ItemFormulario = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  p {
    margin: 2px 0 0 4px;

    color: ${(props) => props.theme.cores.media};

    font-size: 0.857rem;
  }

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    button {
      width: 100% !important;
    }
  }
`;

export const LinhaDatas = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  width: 100%;

  @media screen and (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    width: 100%;

    p {
      width: 100%;
    }
  }

  @media screen and (max-width: 400px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const ConteinerBotao = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;

  width: 100%;

  button {
    width: 100%;
  }

  @media screen and (max-width: 765px) {
    flex-direction: column;
  }
`;
